import MainLayout from '../views/layouts/Main'
import Index from '../views/Index'

/* eslint-disable global-require */
const BoardLayout = () => import(/* webpackChunkName: "board" */ '../views/layouts/Board')
const Board = () => import(/* webpackChunkName: "board" */ '../views/Board')
const Client = () => import(/* webpackChunkName: "board" */ '../views/Client')
const ClientAdd = () => import(/* webpackChunkName: "board" */ '../views/ClientAdd')
const Clients = () => import(/* webpackChunkName: "board" */ '../views/Clients')
const Jobcards = () => import(/* webpackChunkName: "board" */ '../views/Jobcards')
const Jobcard = () => import(/* webpackChunkName: "board" */ '../views/Jobcard')
const JobcardAdd = () => import(/* webpackChunkName: "board" */ '../views/JobcardAdd')
const Overview = () => import(/* webpackChunkName: "board" */ '../views/Overview')
const Profile = () => import(/* webpackChunkName: "board" */ '../views/Profile')
const Vehicles = () => import(/* webpackChunkName: "board" */ '../views/Vehicles')
const Vehicle = () => import(/* webpackChunkName: "board" */ '../views/Vehicle')
const Expenses = () => import(/* webpackChunkName: "board" */ '../views/Expenses')
const Expense = () => import(/* webpackChunkName: "board" */ '../views/Expense')
const ExpenseAdd = () => import(/* webpackChunkName: "board" */ '../views/ExpenseAdd')
const VehicleAdd = () => import(/* webpackChunkName: "board" */ '../views/VehicleAdd')

const Invoices = () => import(/* webpackChunkName: "invoices" */ '../views/Invoices')

const TeamLayout = () => import(/* webpackChunkName: "team" */ '../views/layouts/Team')
const Team = () => import(/* webpackChunkName: "team" */ '../views/Team')
const TeamInvoices = () => import(/* webpackChunkName: "team" */'../views/TeamInvoices')
const TeamExport = () => import(/* webpackChunkName: "team" */'../views/TeamExport')
const TeamOther = () => import(/* webpackChunkName: "team" */'../views/TeamOther')

const JoinTeam = () => import(/* webpackChunkName: "join" */ '../views/JoinTeam')

const HelpLayout = () => import(/* webpackChunkName: "help" */ '../views/layouts/Help')
const HelpInvoiceTemplates = () => import(/* webpackChunkName: "help" */ '../views/HelpInvoiceTemplates')

const FormLayout = () => import(/* webpackChunkName: "form" */ '../views/layouts/Form')
const Login = () => import(/* webpackChunkName: "form" */ '../views/Login')
const LoginForgot = () => import(/* webpackChunkName: "form" */ '../views/LoginForgot')
const LoginReset = () => import(/* webpackChunkName: "form" */ '../views/LoginReset')
const Logout = () => import(/* webpackChunkName: "form" */ '../views/Logout')
const Signup = () => import(/* webpackChunkName: "form" */ '../views/Signup')
const SignupValidate = () => import(/* webpackChunkName: "form" */ '../views/SignupValidate')
const SignupThanks = () => import(/* webpackChunkName: "form" */ '../views/SignupThanks')
const Err401 = () => import(/* webpackChunkName: "ext" */ '../views/errors/401.vue')
const Err404 = () => import(/* webpackChunkName: "ext" */ '../views/errors/404.vue')
/* eslint-enable global-require */

// authorization templates
// const author = { author: true }
// const userIdIn = fieldName => ({ userIdIn: fieldName })
// const role = r => ({ role: r })
const permissions = (...p) => ({ permissions: p })

export default [
  {
    path: '',
    component: MainLayout,
    children: [
      {
        path: '/',
        name: 'Index',
        component: Index,
      },
      {
        path: '/board',
        component: BoardLayout,
        children: [
          {
            path: 'profile',
            name: 'Profile',
            component: Profile,
          },
          {
            path: 'team',
            component: TeamLayout,
            children: [
              {
                path: '',
                name: 'Team',
                component: Team,
              },
              {
                path: 'invoices',
                name: 'TeamInvoices',
                component: TeamInvoices,
              },
              {
                path: 'export',
                name: 'TeamExport',
                component: TeamExport,
                auth: {
                  memberRole: 'ADM',
                },
              },
              {
                path: 'other',
                name: 'TeamOther',
                component: TeamOther,
                auth: permissions('group.write'),
              },
            ],
          },
          {
            path: 'Overview',
            name: 'Overview',
            component: Overview,
            auth: permissions('jobcards.read'),
          },
          {
            path: 'clients',
            name: 'Clients',
            component: Clients,
            auth: permissions('jobcards.read'),
            children: [
              {
                path: 'add',
                name: 'ClientAdd',
                component: ClientAdd,
              },
              {
                path: ':id',
                name: 'Client',
                component: Client,
              },
            ],
          },
          {
            path: 'invoices',
            name: 'Invoices',
            component: Invoices,
            auth: permissions('invoices.read'),
          },
          {
            path: 'jobcards',
            name: 'Jobcards',
            component: Jobcards,
            auth: permissions('jobcards.read'),
          },
          {
            path: 'vehicles',
            name: 'Vehicles',
            component: Vehicles,
            auth: permissions('jobcards.read'),
            children: [
              {
                path: 'add',
                name: 'VehicleAdd',
                component: VehicleAdd,
              },
              {
                path: ':id',
                name: 'Vehicle',
                component: Vehicle,
              },
            ],
          },
          {
            path: 'expenses',
            name: 'Expenses',
            component: Expenses,
            auth: permissions('jobcards.read'),
            children: [
              {
                path: 'add',
                name: 'ExpenseAdd',
                component: ExpenseAdd,
                auth: permissions('jobcards.write'),
              },
              {
                path: ':id',
                name: 'Expense',
                component: Expense,
              },
            ],
          },
          {
            path: '',
            name: 'Board',
            component: Board,
            auth: permissions('jobcards.read'),
            children: [
              {
                path: 'jobcard/add',
                component: JobcardAdd,
                name: 'JobcardAdd',
              },
              {
                path: 'jobcard/:id',
                component: Jobcard,
                name: 'Jobcard',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    component: FormLayout,
    children: [
      {
        path: '',
        name: 'Login',
        component: Login,
      },
      {
        path: 'forgot',
        name: 'LoginForgot',
        component: LoginForgot,
      },
      {
        path: 'reset',
        name: 'LoginReset',
        component: LoginReset,
      },
      {
        path: '/logout',
        name: 'Logout',
        component: Logout,
      },
    ],
  },
  {
    path: '/signup',
    component: FormLayout,
    children: [
      {
        path: '',
        name: 'Signup',
        component: Signup,
      },
      {
        path: '/signup/validate',
        name: 'SignupValidate',
        component: SignupValidate,
      },
      {
        path: '/signup/thank-you',
        name: 'SignupThanks',
        component: SignupThanks,
      },
    ],
  },
  // {
  //   path: '/oauth2/:provider',
  //   name: 'OAuth2',
  //   component: OAuth2,
  // },
  {
    path: '/join/:id/:code',
    component: FormLayout,
    children: [
      {
        path: '',
        name: 'JoinTeam',
        component: JoinTeam,
      },
    ],
  },
  {
    path: '/help',
    name: 'Help',
    component: HelpLayout,
    children: [
      {
        path: 'invoice-templates',
        name: 'HelpInvoiceTemplates',
        component: HelpInvoiceTemplates,
      },
    ],
  },
  {
    path: '/denied',
    name: 'Err401',
    component: Err401,
  },
  {
    path: '*',
    name: 'Err404',
    component: Err404,
  },
]



// WEBPACK FOOTER //
// ./src/router/routes.js